import { defaultTo, isEmpty, upperFirst } from "lodash";
export const mapClientName = (firstname, lastname) => {
    const formattedlastname = upperFirst(defaultTo(lastname, ""));
    const formattedfirstname = isEmpty(lastname) ? upperFirst(firstname) : `, ${upperFirst(firstname)}`
    return formattedlastname + formattedfirstname;
};